console.log('LLLL');
function changeDesign(){

    document.body.style.background = bgColor_form;
    document.body.style.color = textColor_form;
    document.documentElement.style.background = bgColor_form;
    document.documentElement.style.color = textColor_form;
    const displayScreenEl = document.getElementById("displayScreen");
    displayScreenEl.style.width = "1170px";
    displayScreenEl.style.height = "auto";
}


function startFormTrialsWithDelay() {
  changeDesign();
  document.getElementById('divQuestionForm').style.display = 'none';
  document.getElementById('divQuestionForm2').style.display = 'none';
  setTimeout('startFormTrials()', 500);
  }

// Start the accumulated form trials
function startFormTrials() {
  window.activateExclusiveCheckboxes();
  console.log('startFormTrials');
  changeDesign();
  //progressBar
  percProgressBar = computeProgressBar();
  if (progressBar) {
    document.getElementById("progressBar").style.width = percProgressBar + "%";
    document.getElementById("progressBar").style.display = 'block';
  } else {
    document.getElementById("progressBar").style.display = 'none';
  }

  //load the icheck for the new radio and checkboxs
  loadplayerfortrials();

  //reset firstHr
  firstHr = 1;

  // Adds a next button that calls validate/s ave
  var submitControls = '';

  submitControls += '<div class="message-red" id="message-red"></div>';
  submitControls += '<button class="btn btn-primary" type="button" style="font-size:180%;display:block;margin-left:auto;margin-right:auto;margin-bottom:20px;" onclick="return validateFormTrials()">'+mainSurveyButton+'</button>'

  if(language == "hebrew"){
    setHebrewFormAlignment();
  }

  $('#divQuestionForm').append(submitControls);

//   $(':radio').change(
//   function(){
//     $('.choice').text( this.value + ' stars' );
//   }
// )


  // //add sorting COSTI trial
  // for (var iSorts = 0; iSorts < counterSorts; iSorts++)
  // {
  //   var tempSort = document.getElementById('sortItems'+(iSorts+1));
  //   Sortable.create(tempSort, {
  //     animation: 300,
  //     ghostClass: 'ghost',
  //   });
  // }
  // counterSorts = 0;

  window.scrollTo(0, 0);

  if ($('.rangeFormat').length) {
    document.getElementById('divQuestionForm').style.visibility = 'hidden';
    document.getElementById('divQuestionForm2').style.visibility = 'hidden';//daniel-why??

    // finally, show the containing div
    document.getElementById('divQuestionForm').style.display = 'block';
    document.getElementById('divQuestionForm2').style.display = 'block';//daniel-why??

    //for sliders
    $(".rangeFormat").each(function() {
      var self = this;
      $(this).ionRangeSlider(generateSliderOptions(this, function() {
        if (self.getAttribute('data-hide-start') == 'true'){
          $('.irs-slider').hide();
          $(".irs-bar-edge").hide();
        }

        if (self.getAttribute('data-hide-fill')  == 'true') {
          const parent = $(self).parent();
          $(parent).find('.irs-bar').hide();
          $(parent).find('.irs-bar-edge').hide();
        }

        // set the start time for the form type trial
        timeInMs = performance.now();
        document.getElementById('divQuestionForm').style.visibility = 'visible';
        document.getElementById('divQuestionForm2').style.visibility = 'visible';//daniel-why??
      }));

    });

    // .ionRangeSlider(generateSliderOptions(this, function() {
    //   console.log('pp', this);
    //   // set the start time for the form type trial
    //   timeInMs = performance.now();
    //   document.getElementById('divQuestionForm').style.visibility = 'visible';
    //   document.getElementById('divQuestionForm2').style.visibility = 'visible';//daniel-why??
    // }));//start slider



  } else {
    // set the start time for the form type trial
    timeInMs = performance.now();

    if (formInfo.hideStart){
      $('.irs-slider').hide();
      $(".irs-bar-edge").hide();
    }

    // finally, show the containing div
    document.getElementById('divQuestionForm').style.display = 'block';
    document.getElementById('divQuestionForm2').style.display = 'block';//daniel-why??
  }
}

// Generate and a form trial from a trial row
function showFormTrial() {
  console.log('showFormTrial');

  // relevant data for the current form trial
  var qcode = listArrays[allColumns.indexOf('code')][trialRow];
  let headValue = window.trialActualValues['head']
  if (typeof headValue == 'undefined') {
    headValue = columnForTrial('head', trialRow);
  }
  var qquestion = replaceVariables(headValue, undefined, undefined, undefined, 1);
  var qtitle = listArrays[allColumns.indexOf('pageName')][trialRow];
  var qbutton = listArrays[allColumns.indexOf('button1')][trialRow];
  let bodyValue = window.trialActualValues['body']
  if (typeof bodyValue == 'undefined') {
    bodyValue = columnForTrial('body', trialRow);
  }
  var qdetails = replaceVariables(bodyValue, undefined, undefined, undefined, 1);
  var qresponseType = listArrays[allColumns.indexOf('responseType')][trialRow];
  // var qresponseChoicesRaw = listArrays[allColumns.indexOf('responseChoices')][trialRow];

//   let responseOptionsValue = columnForTrial('responseOptions', trialRow);
  let responseOptionsValue = window.trialActualValues['responseOptions']
  if (typeof responseOptionsValue == 'undefined') {
    responseOptionsValue = columnForTrial('responseOptions', trialRow);
  }

  const qresponseChoicesRaw = replaceVariables(responseOptionsValue);
  var qresponseChoices = qresponseChoicesRaw.split(';').filter(function(c) {return c.length != 0});
  // var qresponseChoicesRandomize = listArrays[allColumns.indexOf('responseChoicesRandomize')][trialRow];
  var qresponseChoicesRandomize = listArrays[allColumns.indexOf('responseOptionsRandom')][trialRow];
  var qresponseOther = listArrays[allColumns.indexOf('responseOther')][trialRow];
  var qresponseRows = replaceVariables(listArrays[allColumns.indexOf('responseRows')][trialRow]);
  var qresponseRowsSplit = qresponseRows.split(';').filter(function(c) {return c.length != 0});
  // var qresponseRowsRandomize = listArrays[allColumns.indexOf('responseRowsRandomize')][trialRow];
  var qresponseRowsRandomize = listArrays[allColumns.indexOf('responseRowsRandom')][trialRow];
  var qrequired = listArrays[allColumns.indexOf('required')][trialRow];
  var qseparator = listArrays[allColumns.indexOf('separator')][trialRow];
  var qresponseOrientation = listArrays[allColumns.indexOf('responseOrientation')][trialRow];
  var qresponseKeyRaw = listArrays[allColumns.indexOf('key')][trialRow];
  //var qresponseKey = qresponseKeyRaw.split(';').filter(function(c) {return c.length != 0});
  var qresponseKey = qresponseKeyRaw;

  // sets the 'orientation' which is basically a line break if orientation is defined
  var orienationNewline = qresponseOrientation == 'vertical' ? '<br>' : '';

  // add other
  if (qresponseOther != 'na' && qresponseType != "rank") {
    qresponseChoices.push(qresponseOther);
  }


  qquestion = window.replaceDoubleQuotesWithSingleQuotesInHTMLTags(qquestion);
  qdetails = window.replaceDoubleQuotesWithSingleQuotesInHTMLTags(qdetails);

console.log('oooo' + trialRow);
  // stored information for the current form trial
  // added to displayedFormData for the current cycle
  formInfo = {};
  formInfo.trialRow = trialRow;
  formInfo.rowId = 'qformRow' + trialRow;
  formInfo.responseChoices = qresponseChoices;
  formInfo.responseType = qresponseType;
  formInfo.responseKey = qresponseKey;
  [formInfo.responseRows, formInfo.responseRowsPermutationTable] = getResponseRowsPermutationAndOrderTable(qresponseRowsSplit, qresponseRowsRandomize);
  formInfo.response = [];
  formInfo.responseCodes = [];
  formInfo.randomizedStimOrder = [];
  formInfo.multiLine = false;
  formInfo.multiLineSlider = false; //Only Slider
  formInfo.multiLineOther = false; //Dropdown or Rank
  formInfo.multiLineWithImages = false;
  colSize="col-sm-1";

  // triggers required validation for the current form trial
  if (qrequired != 'na') {
    formInfo.required = true;
  }

  if (qresponseRowsRandomize !== 'na') {
    formInfo.randomizeResponseRows = true;
  }

  // if we have stims defined, we need to display the asset and show
  // the defined response for each of them
  formInfo.hasStims = true;
  formInfo.stimCount = listNoStim[trialRow];
  formInfo.stimCountImages = listNoStim[trialRow];
  // it's reset to 1 to avoid additional logic in the gen loop below
  if (formInfo.stimCount === 0) {
    formInfo.hasStims = false;
    formInfo.stimCount = 1;
    colSize="col-sm-7";
  }

  if (formInfo.stimCount === 1) {
      colSize="col-sm-10";
      if(formInfo.responseType === 'likert') {
        colSize="col-sm-12";
      }
  }

  // if we have responseRows defined, we need to display the asset and show
  // the defined response for each of them
  formInfo.hasResponseRows = false;
  if (formInfo.responseRows.length > 1) {
    formInfo.hasResponseRows = true;
    formInfo.responseRowsCount = formInfo.responseRows.length;
    formInfo.stimCount = formInfo.responseRows.length;

    if(formInfo.responseType == "checkboxes" || formInfo.responseType == "radio"){
        formInfo.multiLine = true;
    }else if(formInfo.responseType == "slider"){
        formInfo.multiLineSlider = true;
    }else if(formInfo.responseType == "dropdown" || formInfo.responseType == "rank" || formInfo.responseType == "box" || formInfo.responseType == "comment" || formInfo.responseType == "date" || formInfo.responseType == "stars"){
        formInfo.multiLineOther = true;
    }

    colSize="col-sm-2";
  }

  if(columnForTrial('stimOptions', trialRow).includes('random')){
    formInfo.randomizedStimOrder = getFormRandomStimOrder(images, formInfo.stimCountImages, trialRow);
  }

  if(formInfo.hasStims && (formInfo.multiLine ||  formInfo.multiLineOther ||  formInfo.multiLineSlider)){
      formInfo.multiLineWithImages = true;
  }

  // the generic id for the elements containing response data
  formInfo.inputIds = [];

  // start the layout
  // var qBuild = '<table class="qform" style="border:none; width:' + canvasWidth + 'px;">';
  var qBuild = "";

  if(firstHr == 1){
    if(qtitle == "na"){qtitle = "";}
    document.getElementById('survey-title').innerHTML = qtitle;
  }

  if (qbutton=="na"){
    if (trial < noTrials) {
      if (listArrays[allColumns.indexOf('type')][stimOrder[trial + 1]] !== 'form') {
        mainSurveyButton=trans("general.FINISH");
      } else {
        mainSurveyButton=trans("general.NEXT");
      }
    }
    else {
      mainSurveyButton=trans("general.FINISH");
    }
  }
  else{
    mainSurveyButton = qbutton;
  }
  firstHr = 0;
  onlyMultiLine=0;

  // if responseType is 'na' it means we only display the text
  if(formInfo.responseType == "na" && qcode == "na"){
      if (qquestion && qquestion != 'na') {
        qBuild += '<div class="ins-title-tform2">' + qquestion + '</div>';
      }
      if (qdetails && qdetails != 'na') {
        qBuild += '<div class="ins-description-tform2">'+ qdetails +'</div>';
      }
      if (formInfo.hasStims &&formInfo.stimCountImages > 0) {
        qBuild += '<div class="form-group noBottom" style="flex-wrap: wrap;"><div class="col-sm-2">&nbsp;</div>';
        qBuild += '<div class="multiLineWithImages">';
        for (var fStimIndex = 0; fStimIndex < formInfo.stimCountImages; fStimIndex++) {
        

            // stim has %varname% and exists in userVars 
          
          let currentImage = images[fStimIndex + 1][trialRow];
          if(formInfo.randomizedStimOrder[fStimIndex] !== undefined) {
            currentImage = formInfo.randomizedStimOrder[fStimIndex];
          }

          let src = "";
          if(currentImage !== undefined && currentImage.src !== undefined) {
            src = currentImage.src;
            if(currentImage.type && currentImage.type == "dynamic") {
              src = generateDynamicImage(currentImage.text).src;
            }
          }

          qBuild += `<img src="${src}">`;
        }
        qBuild += '</div>';
        qBuild += '</div>';
      }
  }else{

      // add the question and details row
      // add a row with errId id that is later used to display validation errors
      formInfo.errId = 'qFormError' + trialRow;
      qBuild += '<div class="form-normal" id="' + formInfo.rowId  + '">';
      qBuild +=  '        <label class="col-sm-12 control-label" style="padding-left:0">' + qquestion + '</label></div>';
      if(qdetails !== "na"){
        qBuild +=  '       <div class="form-normal2"><small class="text-navy">'+ qdetails +'</small></div>';
      }
      qBuild +=  '        <div class="form-normal2"><small class="text-error" id="' + formInfo.errId +'"></small></div>';
      qBuild +=  '        <div class="form-group noBottom withImages" style="flex-wrap: wrap;">';

      if(formInfo.multiLine && !formInfo.multiLineWithImages){
          qBuild += '</div>';
          qBuild += '<div class="dtable">';
            qBuild += '<div class="dtr">';
            qBuild += '<div class="dtd"></div>';
          onlyMultiLine=1;
          for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
              qBuild += '<div class="dtd" style="text-align:center;"><b>'+formInfo.responseChoices[iRCs]+'</b></div>';
          }
          qBuild += '</div>';
      }else if((formInfo.multiLineSlider || formInfo.multiLineOther) && !formInfo.multiLineWithImages){
          qBuild += '</div>';
          qBuild += '<div class="form-group noBottom" style="flex-wrap: wrap;">';
      }

      var iMultiMax = 1;

      if(formInfo.multiLineWithImages){
          iMultiMax = formInfo.stimCountImages;
      }

      for (var iMulti = 0; iMulti < iMultiMax; iMulti++) {
        
          let currentImage = images[iMulti + 1][trialRow];
          if(formInfo.randomizedStimOrder[iMulti]) {
            currentImage = formInfo.randomizedStimOrder[iMulti];
          }
          let src = currentImage.src;
          if(currentImage.type && currentImage.type == "dynamic") {
            src = generateDynamicImage(currentImage.text).src;
          }


          if(formInfo.multiLineWithImages){
              qBuild += '</div>';
              qBuild += '<div class="form-group noBottom" style="flex-wrap: wrap;"><div class="col-sm-2">&nbsp;</div>';
              qBuild += `<div class="multiLineWithImages"><img src="${src}"></div>`;
              qBuild += '</div>';
              qBuild += '<div class="form-group noBottom multiLineWithImages" style="flex-wrap: wrap;">';
          }
          if(formInfo.multiLine && formInfo.multiLineWithImages){
              qBuild += '</div>';

              qBuild += '<div class="dtable">';
              qBuild += '<div class="dtr">';
              qBuild += '<div class="dtd"></div>';

              for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
                  qBuild += '<div class="dtd" style="text-align:center;"><b>'+formInfo.responseChoices[iRCs]+'</b></div>';
              }

              qBuild += '</div>';
              onlyMultiLine=1;
          }
          if((formInfo.multiLineSlider || formInfo.multiLineOther) && formInfo.multiLineWithImages){
              qBuild += '</div>';
              qBuild += '<div class="form-group noBottom ppppp" style="flex-wrap: wrap;">';
          }

          // begin a question row for the current response(s)
          for (var iStim = 0; iStim < formInfo.stimCount; iStim++) {
            if(onlyMultiLine==1){}
            else if(formInfo.multiLine || formInfo.multiLineSlider || formInfo.multiLineOther){
                qBuild += '<label class="col-sm-2 control-label labelMultiLine">' + (formInfo.responseRows[iStim] != 'na' ? formInfo.responseRows[iStim] : '') + '</label>';
            }else{
                // begin a question cell for each stim
                var centerSlider = formInfo.responseType == 'slider' ? 'margin:0 auto;' : '';
                colSize = formInfo.responseType === 'likert' ? 'col-sm-12' : colSize; 
                if (formInfo.responseType === 'likert') {
                    centerSlider += 'width:100%;';
                }
                qBuild += '<div class="'+colSize+'" style="'+centerSlider+'">';
            }

            var currentElementId = "";

            // generic response container element id
            if(iMultiMax > 1){
                currentElementId = 'qFormElement' + trialRow + iStim + iMulti;
            }else{
                currentElementId = 'qFormElement' + trialRow + iStim
            }

            // let performance.now() to generate a unique id for each element, but replace the decimal point with an underscore to avoid jquery selector issues, e.g. #qFormElement123.456
            currentElementId += performance.now().toString().replace('.', '_');
            formInfo.inputIds.push(currentElementId);

            // response choice randomization
            var randomizeChoices = false;
            var randomResponsesHelper;
            var responsesObjectHelper;
            if (qresponseChoicesRandomize != 'na') {
              randomizeChoices = true;
              responsesObjectHelper = {};
              randomResponsesHelper = formInfo.responseChoices.slice(0);
              for (var i = 0; i < formInfo.responseChoices.length; i++) {
                 responsesObjectHelper[formInfo.responseChoices[i]] = i;
               }
            }

            formInfo.randomizeChoices = randomizeChoices;

            // store the original orders and display order in case of randomization
            formInfo.choiceOrder = [];
            formInfo.choiceDisplayOrder = [];

            // show the stim asset
            // TODO: videos

            let currentImage = images[iStim + 1][trialRow];
            if(formInfo.randomizedStimOrder[iStim] !== undefined) {
              currentImage = formInfo.randomizedStimOrder[iStim];
            }
            let src = "";
            if(currentImage !== undefined && currentImage.src !== undefined) {
              src = currentImage.src;
              if(currentImage.type !== undefined && currentImage.type == "dynamic") {
                src = generateDynamicImage(currentImage.text).src;
              }
            }

            if (formInfo.hasStims && !formInfo.multiLineWithImages) {
              qBuild += `<img src="${src}">`;
            }

            if(formInfo.hasResponseRows && !formInfo.multiLine && !formInfo.multiLineSlider && !formInfo.multiLineOther){
              var labelClass = formInfo.responseType == 'likert' ? 'likert-row-label' : '';
              qBuild += '<label class="'+ labelClass +'">' + formInfo.responseRows[iStim] + '</label>';
            }


            var label = qquestion + ' ' + (formInfo.responseRows[iStim] != 'na' ? formInfo.responseRows[iStim] : '');

            // response type specific logic; each response type requires significantly different output
            switch (formInfo.responseType) {
              case 'box':
                formInfo.inputType = 'text';
                if (formInfo.responseChoices.indexOf('email') > -1) {
                  formInfo.inputType = 'email';
                } else if (formInfo.responseChoices.indexOf('numeric') > -1) {
                  formInfo.inputType = 'number';
                }
                qBuild += '<input title="' + label + '" class="form-control qFormInput" type="' + formInfo.inputType + '" id="' + currentElementId + '" style="width:100%" spellcheck="false">';
              break;

              case 'comment':
                qBuild += '<textarea  title="' + label + '" class="form-control qFormInput" rows="5" id="' + currentElementId + '" style="width:100%" spellcheck="false"></textarea>';
              break;

              case 'date':
                qBuild += '<input  title="' + label + '" class="form-control" type="date" id="' + currentElementId + '">';
              break;

              case 'radio':
              case 'checkboxes':
                var multiType;
                if (qresponseType == 'checkboxes') {
                  multiType = 'checkbox'
                } else {
                  multiType = 'radio'
                }

                if(formInfo.multiLine){
                    qBuild += '<form class="dtr" action="" id="' + currentElementId + '">';
                    qBuild += '<div style="display:flex;flex-direction:column;" class="dtd control-label lblr">' + formInfo.responseRows[iStim] + '</div>';
                }
                else{
                    qBuild += '<form action="" style="display:flex;flex-direction:column;" id="' + currentElementId + '">';
                }

                for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
                  formInfo.choiceOrder.push(iRCs);

                  var responseChoice = getNextResponseChoice(randomizeChoices, qresponseOther, qresponseType, randomResponsesHelper, responsesObjectHelper, formInfo, iRCs);
                  let exclusiveClass = "";
                  if (isExclusiveOption(responseChoice)) {
                    if(responseChoice == qresponseOther) {
                      qresponseOther = removeExclusiveOptionKeyword(qresponseOther);
                    }

                    responseChoice = removeExclusiveOptionKeyword(responseChoice);
                    exclusiveClass = "exclusive";
                  }

                  if(formInfo.multiLine){
                      qBuild += '<div class="dtd">';
                      qBuild += '<div class="radio i-checks">';
                      // qBuild += '<label style="padding-left: 0px !important;">';
                      var label = formInfo.responseRows[iStim] +  ' '  +  formInfo.responseChoices[iRCs];
                      if(responseChoice == qresponseOther){
                          qBuild += '<input class="' + exclusiveClass + '" title="' + label + '" data-element="'+currentElementId+'-other" data-other="yes" type="' + multiType + '" name="' + currentElementId +
                                '" value="' + responseChoice +'">';
                      }else{
                          qBuild += '<input class="' + exclusiveClass + '" title="' + label + '" type="' + multiType + '" name="' + currentElementId +
                                '" value="' + responseChoice +'">';
                      }
                      // qBuild += '</label>';
                      qBuild += '<label class="qform-mobile-label">'+ responseChoice + '</label>';
                      qBuild += '</div>';

                      if(responseChoice == qresponseOther){
                          // qBuild += '<div class="margin_other col-sm-2">';
                          qBuild += '<div class="margin_other">';//latest from daniel
                          qBuild += '<input title="Other"  style="display:none" class="form-control other-input" type="text" id="'+currentElementId+'-other" name="'+currentElementId+'-other" spellcheck="false">';
                          qBuild += '</div>';
                      }

                      qBuild += '</div>';

                  }else{

                      if(responseChoice == qresponseOther){
                          qBuild += `<div class="radio i-checks other-inline ${exclusiveClass}">`;
                      }else{
                          qBuild += '<div class="radio i-checks ' + exclusiveClass + '">';
                      }

                      qBuild += '<label>';

                      if(responseChoice == qresponseOther){
                          qBuild += '<input class="'+exclusiveClass+'" title="Other" data-element="'+currentElementId+'-other" data-other="yes" type="' +
                                multiType + '" name="'+currentElementId+
                                '" value="' + quoteattr(responseChoice) +'"> ' + responseChoice +
                                orienationNewline;
                          qBuild += '</label>';
                          qBuild += '</div>';
                          // qBuild += '<div class="margin_other col-sm-2">';
                          qBuild += '<div class="margin_other ' + exclusiveClass + '">';//latest from daniel
                          qBuild += '<input title="Other" style="display:none" class="form-control" type="text" id="'+currentElementId+'-other" name="'+currentElementId+'-other" spellcheck="false">';
                          qBuild += '</div>';

                      }else{
                          qBuild += '<input class="' + exclusiveClass + '" type="' + multiType + '" name="' + currentElementId +
                                '" value="' + quoteattr(responseChoice) +'"> ' + responseChoice +
                                orienationNewline;
                          qBuild += '</label>';
                          qBuild += '</div>';
                      }

                  }
                }

                if(formInfo.multiLine){
                    qBuild += '</form>';
                }
                else{
                    qBuild += '</form>';
                }
              break;
              case 'likert':
                var multiType;
                multiType = 'radio';

                if(formInfo.multiLine){
                    qBuild += '<form class="dtr likert-form likert-multiline" action="" id="' + currentElementId + '">';
                    qBuild += '<div class="dtd control-label lblr">' + formInfo.responseRows[iStim] + '</div>';
                }
                else{
                    qBuild += '<form action="" class="likert-form" id="' + currentElementId + '">';
                }

                for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
                  formInfo.choiceOrder.push(iRCs);

                  var responseChoice = getNextResponseChoice(randomizeChoices, qresponseOther, qresponseType, randomResponsesHelper, responsesObjectHelper, formInfo, iRCs);

                  if(formInfo.multiLine){
                      qBuild += '<div class="dtd">';
                      qBuild += '<div class="radio i-checks horizontal-radio">';
                      qBuild += '<label class="likert-label">';
                      var label = formInfo.responseRows[iStim] +  ' '  +  formInfo.responseChoices[iRCs];
                      qBuild += '<input title="' + label + '" type="' + multiType + '" name="' + currentElementId +
                        '" value="' + responseChoice +'">' + '<br/>' + responseChoice;
                      qBuild += '</div>';
                      qBuild += '</div>';
                      qBuild += '</label>'

                  }else{
                    qBuild += '<div class="radio i-checks horizontal-radio">';
                    qBuild += '<label class="likert-label">';
                    qBuild += '<input type="' + multiType + '" name="' + currentElementId +
                        '" value="' + quoteattr(responseChoice) +'"> ' + '<br/>' + responseChoice;
                    qBuild += '</div>';
                    qBuild += '</label>';
                  }
                }
                qBuild += '</form>';
                break;
              case 'dropdown':
                var otherActive = false;
                if(formInfo.responseChoices[formInfo.responseChoices.length-1] == qresponseOther){
                    otherActive = true;
                }

                if(otherActive){
                    qBuild += '<select title="' + label + '"  onchange="activate_other(\''+currentElementId+'\',this.value,\''+qresponseOther+'\')" class="form-control other-inline" id="'+currentElementId+'">';
                }else{
                    qBuild += '<select title="' + label + '" class="form-control qFormInput" id="' + currentElementId + '">';
                }

                qBuild += '<option>Select:</option>';

                for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
                  var responseChoice = getNextResponseChoice(randomizeChoices, qresponseOther, qresponseType, randomResponsesHelper, responsesObjectHelper, formInfo, iRCs);

                  qBuild += '<option value="' + responseChoice +'">' + responseChoice + '</option>';
                }
                qBuild += '</select>';

                if(otherActive){
                    // qBuild += '<div class="margin_other col-sm-2">';
                    qBuild += '<div class="margin_other">';//latest from daniel
                    qBuild += '<input title="Other" style="display:none" class="form-control" type="text" id="'+currentElementId+'-other" name="'+currentElementId+'-other" spellcheck="false">';
                    qBuild += '</div>';
                }

              break;

              case 'stars':
                qBuild += '<span class="star-rating" id="' + currentElementId + '">';
                qBuild += '<input title="' + label + ' 1" type="radio" name="' + currentElementId + '" value="1"><i></i>';
                qBuild += '<input title="' + label + ' 2" type="radio" name="' + currentElementId + '" value="2"><i></i>';
                qBuild += '<input title="' + label + ' 3" type="radio" name="' + currentElementId + '" value="3"><i></i>';
                qBuild += '<input title="' + label + ' 4"  type="radio" name="' + currentElementId + '" value="4"><i></i>';
                qBuild += '<input title="' + label + ' 5" type="radio" name="' + currentElementId + '" value="5"><i></i>';
                qBuild += '</span>';
              break;

              case 'slider':
                var sliderType = "numbers";
                var rMin = "";
                var rMax = "";
                var rMinLabel = "";
                var rMaxLabel = "";
                var rValues = "";
                var rStart = "";
                var rStartLabel = "";
                var rStep = 1;
                var rHideValue = "false";
                var rHideRange = "false";
                var rShowLabels = "true";
                var rGridNum = "";
                rHideValue=false;
                rHideStart=false;
                rHideGrid=false;
                rHideMinMax=false;
                // var rangeLabelId = currentElementId + 'label';
                var sliderResponseChoices = formInfo.responseChoices[0].split('_').filter(function(c) {return c.length != 0});

                //eliminate min and max labels if any
                if (sliderResponseChoices[0].indexOf('(')>-1)
                {
                    var separators = ['\\\(','\\\)'];
                    tempSplit = sliderResponseChoices[0].split(new RegExp(separators.join('|'), 'g')).filter(function(c) {return c.length != 0});
                    sliderResponseChoices[0] = tempSplit[0];
                    rMinLabel = tempSplit[1];
                }
                if (sliderResponseChoices.length>1 && sliderResponseChoices[1].indexOf('(')>-1)
                {
                    var separators = ['\\\(','\\\)'];
                    tempSplit = sliderResponseChoices[1].split(new RegExp(separators.join('|'), 'g')).filter(function(c) {return c.length != 0});
                    sliderResponseChoices[1] = tempSplit[0];
                    rMaxLabel = tempSplit[1];
                }

                //get info
                if (sliderResponseChoices.length == 1)
                {
                  if(isNumeric(sliderResponseChoices[0])){
                      rMin = 0;
                      rMax = sliderResponseChoices[0];
                      rStart = 0;
                  }else{
                      rMin = 0;
                      rMax = 100;
                      rStart = 0;
                  }

                }else if(sliderResponseChoices.length == 2) {

                    if(!isNumeric(sliderResponseChoices[0]) || !isNumeric(sliderResponseChoices[1])){
                        sliderType = "labels";
                        rValues = sliderResponseChoices.join(',');
                        rStart = sliderResponseChoices[0];
                        rStep = sliderResponseChoices.length;
                    }else if(+sliderResponseChoices[0] > +sliderResponseChoices[1]){
                        rStart = 0;
                        rMin = 0;
                        rMax = sliderResponseChoices[0];
                        rStep = sliderResponseChoices[1];
                    }else{
                        rStart = sliderResponseChoices[0];
                        rMin = sliderResponseChoices[0];
                        rMax = sliderResponseChoices[1];
                    }

                }else if(sliderResponseChoices.length == 3) {

                    if(!isNumeric(sliderResponseChoices[0]) || !isNumeric(sliderResponseChoices[1]) || !isNumeric(sliderResponseChoices[2])){
                        if(!isNumeric(sliderResponseChoices[2])){
                            sliderType = "labels";
                            rValues = sliderResponseChoices.join(',');
                            rStart = sliderResponseChoices[0];
                            rStep = sliderResponseChoices.length;
                        }else{
                            sliderType = "labels";
                            rValues = sliderResponseChoices[0] + "," + sliderResponseChoices[1];
                            rStart = sliderResponseChoices[0];
                            rStep = sliderResponseChoices[2];
                            rHideGrid=true;
                        }
                    }else{
                        if((+sliderResponseChoices[0] < +sliderResponseChoices[1]) && (+sliderResponseChoices[1] > +sliderResponseChoices[2])){
                            rStart = sliderResponseChoices[0];
                            rMin = sliderResponseChoices[0];
                            rMax = sliderResponseChoices[1];
                            rStep = sliderResponseChoices[2];
                        }else{
                            rValues = sliderResponseChoices.join(',');
                            rStart = sliderResponseChoices[0];
                            rStep = sliderResponseChoices.length;
                        }
                    }

                }else{

                    sliderType = "labels";
                    rValues = sliderResponseChoices.join(',');
                    rStart = sliderResponseChoices[0];
                    rStep = sliderResponseChoices.length;
                }

                if(formInfo.responseChoices.length > 1){
                    rStart = formInfo.responseChoices[1];
                }
                if(!isNumeric(rStart)){
                  rStartLabel = sliderResponseChoices.indexOf(rStart);
                }
                if(formInfo.responseChoices.length > 1)
                {
                  var flags = formInfo.responseChoices.slice(1);
                  if (flags.indexOf('hideValue')>-1){rHideValue=true;}
                  if (flags.indexOf('hideStart')>-1){rHideStart=true;rHideValue=true;}
                  if (flags.indexOf('hideGrid')>-1){rHideGrid=true;}
                  if (flags.indexOf('hideMinMax')>-1){rHideMinMax=true;}
                }

                if(formInfo.responseChoices.length > 4){
                    rShowLabels = formInfo.responseChoices[4];
                }

                if(formInfo.multiLineSlider){
                    qBuild += '<div class="col-sm-10">';
                }

                var rHideFill = false
                if (columnForTrial('responseOptions', formInfo.trialRow).indexOf('removeFill') >= 0 || rHideStart) {
                  rHideFill = true;
                }

                if(rMax>0){
                    qBuild += '<input title="'+qquestion+'" type="text" id="' + currentElementId + '" data-type="single" data-min="'+quoteattr(rMin)+'" data-max="'+ quoteattr(rMax) + '" data-from="'+quoteattr(rStart)+'" data-step="'+quoteattr(rStep)+
        '" data-hide-min-max="'+rHideMinMax+'" data-hide-fill="' +rHideFill+ '" data-hide-start="'+ rHideStart +'" data-hide-from-to="'+rHideValue+'" data-grid="'+!rHideGrid+'" data-grid-num="20" data-grid-snap="true" class="rangeFormat" data-min-label="' + rMinLabel +'" data-max-label="' + rMaxLabel +'" />';

                }else{
                    qBuild += '<input title="'+qquestion+'" type="text" id="' + currentElementId + '" data-type="single" data-from="'+quoteattr(rStartLabel)+'" data-values="' + quoteattr(rValues) + '" data-step="'+quoteattr(rStep)+
        '"data-hide-min-max="'+rHideMinMax+'" data-hide-fill="' +rHideFill+ '" data-hide-start="'+ rHideStart +'" data-hide-from-to="'+rHideValue+'" data-grid="'+!rHideGrid+'" data-grid-num="10" data-grid-snap="false" class="rangeFormat" data-min-label="' + rMinLabel +'" data-max-label="' + rMaxLabel +'" />';
                }

                if(formInfo.multiLineSlider || formInfo.multiLineOther){
                    qBuild += '</div>';
                }
    formInfo.hideStart = rHideStart;
    formInfo.rMin = rMin;
    formInfo.rMax = rMax;
    formInfo.rMinLabel = rMinLabel;
    formInfo.rMaxLabel = rMaxLabel;
              break;

              case 'rank':
                // counterSorts++;
                // qBuild += '<ul id="sortItems'+counterSorts+'" class="block__list block__list_words">';
                qBuild += '<ul class="sortable col-sm-10">';
                var counter=0;
                var responseRank="";

                for (var iRCs = 0, len = formInfo.responseChoices.length; iRCs < len; iRCs++) {
                  counter++;
                  responseRank += counter+";";
                  formInfo.choiceOrder.push(iRCs);

                  var responseChoice = getNextResponseChoice(randomizeChoices, qresponseOther, qresponseType, randomResponsesHelper, responsesObjectHelper, formInfo, iRCs);

                  qBuild += '<li class="ui-state-default" data-rank-element="'+currentElementId+'" data-rank-id="'+counter+'">';
                  qBuild += responseChoice;
                  qBuild += '</li>';

                }
                responseRank = responseRank.substring(0, responseRank.length - 1);
                qBuild += '<input type="hidden" id="'+currentElementId+'" value="'+responseRank+'" />';
                qBuild += '</ul>';
              break;

              default: // na/none/empty
                // TODO
                qBuild += '<p>' + 'not implemented' + '</p>';
              break;
            }
            if(onlyMultiLine==1){}
            else if(formInfo.multiLine || formInfo.multiLineSlider || formInfo.multiLineOther){
                qBuild += '</div>';
                qBuild += '<div class="form-group noBottom" style="flex-wrap: wrap;">';
            }else{
                // end question cell
                qBuild += '</div>';
            }
          }
      }

      if(onlyMultiLine==1){
                qBuild += '</div>';
      }

      // end question row
      qBuild += '</div>';
  }


  // add a horizontal line if separator is defined
  if (qseparator !== 'na') {
        qBuild += '<div class="hr-line-dashed"></div>';
  } else {
    qBuild += '<br>';
  }

  // store the data for this form trial for later validation and saving
  displayedFormData.push(formInfo);


  // append generated table to the div container for form trials

  // qBuild = "<div style='visibility:hidden' id='ff'>" + qBuild  + "</div>";
  $('#divQuestionForm').append(qBuild);

  // window.setTimeout(function () {
  //   document.getElementById('ff').style.visibility = 'visible';
  // }, 300)

  // here we have the trial included in the currennt screen
  const shouldHavePageBreak = shouldEndFormScreen(trialRow, trial, window.columnForTrial, window.stimOrder);

  if (shouldHavePageBreak) {
    startFormTrialsWithDelay();
    return;
  }

  // if there are additional trial rows after this one, check if the next one is a form as well
  if (trial < noTrials) {
    if (listArrays[allColumns.indexOf('type')][stimOrder[trial + 1]] == 'form') {
      // advance the trial loop
      main();
    } else {
      // otherwise, just start with what we have so far
      startFormTrialsWithDelay();
    }
  }
}

// activate other option for dropdown
function activate_other(currentElementId,value,otherValue) {
    if(value == otherValue){
        document.getElementById(currentElementId + "-other").style.display="";
    }else{
        document.getElementById(currentElementId + "-other").style.display="none";
    }
}

// email validation helper
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

//return checked values from radio or checkbox or dropdown
function getCheckedValue(responseChoices,checkedP,currentElementId) {
    var iResponses = [];
    for( i = 0; i < checkedP.length; i++ ) {
        if((document.getElementById(currentElementId + "-other")) && responseChoices.length == checkedP[i]){
            console.log(currentElementId + "-other");
            var otherValue = document.getElementById(currentElementId + "-other").value;
            iResponses[i]=otherValue;
        }else{
            iResponses[i]=responseChoices[checkedP[i]-1];
        }
    }
    return iResponses;
}

//check if is numeric
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

//return checked values from rank
function getCheckedValuesRank(responseChoices,userResponse) {
    var userResponseOPT = userResponse.split(';').filter(function(c) {return c.length != 0});
    var iResponses = "";
    for( i = 0; i < userResponseOPT.length; i++ ) {
        iResponses += responseChoices[userResponseOPT[i]-1].trim()+";";
    }
    iResponses = iResponses.substring(0, iResponses.length - 1);
    return iResponses;
}

//return checked positions from radio or checkbox
function getCheckedPosition(groupName) {
    var radios = document.getElementsByName( groupName );
    var iResponses = [];
    var position = 0;
    for( i = 0; i < radios.length; i++ ) {
        if( radios[i].checked ) {
            iResponses[position]=i+1;
            position++;
        }
    }

    return iResponses;
}

// validate all displayed form trials
function validateFormTrials(newTrial) {
  var valErrors = false;
  var fieldRequiredText = trans("forms.Required");
  var fieldMessageRequired = trans('forms.You need to fill in all required answers first');

  // console.debug('validate called, form info:');
  // console.debug(displayedFormData);
  var iFData;
  var inputsPositionControl;

  //start validating data from the current page and not from all previous pages
  if(inputsPosition > 0){
        iFData = inputsPosition;
        inputsPositionSaveData = inputsPosition;
        inputsPositionControl = inputsPosition;
   }else{
        iFData = 0;
        inputsPositionSaveData = 0;
   }

   var formControl = displayedFormData;

  for (iFData, formDataLen = displayedFormData.length; iFData < formDataLen; iFData++) {
    // empty previously recorded data
    inputsPosition = iFData+1; //save position and avoid re-validate inputs from old pages

    displayedFormData[iFData].response.length = 0;
    displayedFormData[iFData].responseCodes.length = 0;

    var formInfo = displayedFormData[iFData];
    var isValid = true;
    var countInputs = 0;

    for (var iInputs = 0, inputsLen = formInfo.inputIds.length; iInputs < inputsLen; iInputs++) {
      var currentElementId = formInfo.inputIds[iInputs];

      switch (formInfo.responseType) {
        case 'box':
          var inputFieldValue = $('#' + currentElementId).val();
          if (formInfo.required && inputFieldValue == '') {
            $('#' + formInfo.errId).text(fieldRequiredText);
            isValid = false;
          }

          if (formInfo.inputType == 'email') {
            if (!validateEmail(inputFieldValue)) {
              $('#' + formInfo.errId).text('Please enter a valid email.');
              isValid = false;
            }
          }

          displayedFormData[iFData].response.push(inputFieldValue);

        break;
        case 'comment':
        case 'date':
        case 'slider':
          console.log('required', formInfo.required);

          if ( formInfo.responseType == 'slider' && formInfo.required && !$('#' + currentElementId).data('touched') ) {
            isValid = false;
          }

          var inputFieldValue = $('#' + currentElementId).val();
          if (formInfo.required && inputFieldValue == '') {
            $('#' + formInfo.errId).text(fieldRequiredText);
            isValid = false;
          }

          // this makes slider value 'na' if slider wasn't touched commenting it until we change this again
          if(formInfo.responseType === 'slider' && !$('#' + currentElementId).data('touched') && formInfo.hideStart){
            inputFieldValue = 'na';
          }

          displayedFormData[iFData].response.push([inputFieldValue]);

          if ( formInfo.responseType == 'slider') {
            var slider = $('#' + currentElementId).data("ionRangeSlider");

            var sliderResponseCode = slider.old_from;

            if($(slider.input).attr('data-values')){
              sliderResponseCode++;
            }

            // this makes slider value 'na' if slider wasn't touched commenting it until we change this again
            if(!$('#' + currentElementId).data('touched') && formInfo.hideStart){
              sliderResponseCode = 'na';
            }

            displayedFormData[iFData].responseCodes.push([sliderResponseCode]);
          }
        break;
        case 'radio':
        case 'checkboxes':
        case 'likert':
          if (formInfo.required) {
            var inputRadioCheck = $('input[name=' + currentElementId + ']:checked', '#' + currentElementId).length;

            if (inputRadioCheck == 0) {
              $('#' + formInfo.errId).text(fieldRequiredText);
              isValid = false;
            }

            const otherInput = document.getElementById(`${currentElementId}-other`);
            if(otherInput !== null && otherInput.style.display !== "none" && otherInput.value.trim() === "") {
              $('#' + formInfo.errId).text(fieldRequiredText);
              isValid = false;
            }
          }
          var checkedP = [];
          var checkedV = [];
          checkedP=getCheckedPosition(currentElementId);
          if (formInfo.randomizeChoices) {
            var newCheckedP = [];
            for (var i = 0; i < checkedP.length; i++) {
              if (typeof formInfo.choiceDisplayOrder[i] != 'undefined') {
                newCheckedP[i] = formInfo.choiceDisplayOrder[checkedP[i] - 1] + 1;
              }
            }
            checkedP = newCheckedP;
          }

          checkedV=getCheckedValue(formInfo.responseChoices,checkedP,currentElementId);
          displayedFormData[iFData].responseCodes.push(checkedP);
          displayedFormData[iFData].response.push(checkedV);

        break;
        case 'dropdown':
          var inputFieldValue = $('#' + currentElementId + ' option:selected').index();
          if (formInfo.required && inputFieldValue == '') {
            isValid = false;
            $('#' + formInfo.errId).text(fieldRequiredText);
          }

          var e = document.getElementById(currentElementId);
          var checkedP = [];
          var checkedV = [];
          checkedP[0]=e.selectedIndex;
          checkedV=getCheckedValue(formInfo.responseChoices,checkedP,currentElementId);
          displayedFormData[iFData].response.push(checkedV);
          displayedFormData[iFData].responseCodes.push(e.selectedIndex);

        break;
        case 'stars':
          if (formInfo.required) {
            var inputStarsCheck = $('input[name=' + currentElementId + ']:checked', '#' + currentElementId).length;

            if (inputStarsCheck == 0) {
              $('#' + formInfo.errId).text(fieldRequiredText);
              isValid = false;
            }
          }

          var checkedGroup = $('input[name=' + currentElementId + ']:checked', '#' + currentElementId);
          var checkedElements = [];

          checkedGroup.each(function() {
            checkedElements.push(($(this).index() + 2) / 2);
          });

          displayedFormData[iFData].response.push(checkedElements);

        break;
        case 'rank':
            var inputFieldValue = $('#' + currentElementId).val();

            if (formInfo.required && inputFieldValue == '') {
                $('#' + formInfo.errId).text(fieldRequiredText);
                isValid = false;
             }
             var checkedV = "";

             checkedV=getCheckedValuesRank(formInfo.responseChoices, inputFieldValue, currentElementId);
             displayedFormData[iFData].response.push([checkedV]);
             displayedFormData[iFData].responseCodes.push([inputFieldValue]);
        break;
        default:  // TODO ?
          console.log('question form empty/none/na')
        break;
      }
    }



    if (isValid) {
      $('#' + formInfo.errId).text('');
    } else {
      valErrors = true;
    }

  }

  if (valErrors) {
    $('#message-red').text(fieldMessageRequired);
    inputsPosition = inputsPositionControl; //if there is an error come back to the initial position of the current page
    displayedFormData = formControl;
  } else {
    saveQuestionForms(newTrial);
  }
};

function getDateFormat(){
    Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
    }

    d = new Date,
     dformat = [(d.getMonth()+1).padLeft(),
               d.getDate().padLeft(),
               d.getFullYear()].join('/') +' ' +
              [d.getHours().padLeft(),
               d.getMinutes().padLeft(),
               d.getSeconds().padLeft()].join(':');
    return dformat;
}

function saveQuestionForms(newTrial) {
  //console.debug('saveQuestionForms:', displayedFormData);

  tempTimestamp = Math.round(performance.now() - startTime);
  tempRT = Math.round(performance.now() - timeInMs);

  // responsePresOrder
  // formData.responseDisplayOrder

  var iFData;

  //start saving data from the current page and not from all previous pages
  if(inputsPositionSaveData > 0){
        iFData = inputsPositionSaveData;
   }else{
        iFData = 0;
   }

  for (iFData, iFLen = displayedFormData.length; iFData < iFLen; iFData++) {
    var formData = displayedFormData[iFData];

    if (formData.responseType!=="na") {

    //console.log('formData.response', formData.response);

    var formResponse = getChosenResponse(formData);

    var chosenResponse = formResponse[0];
    if(typeof chosenResponse == "string"){
      chosenResponse = chosenResponse.trim();
    }
    var chosenResponseCodes = formResponse[1];

    chosenResponseLen = formData.response.length;
    chosenResponseCodesLen = formData.responseCodes.length;

    window.timestamps.push(tempTimestamp);
    window.RTs.push(tempRT);
    window.RTkeys.push('');

    window.ITI_ms.push(window.realITI_temp);
    window.ITI_f.push("na");
    window.ITI_fDuration.push("na");

    window.ISI_ms.push(window.realISI_temp);
    window.ISI_f.push("na");
    window.ISI_fDuration.push("na");

    window.presTime_ms.push(window.presTime_actual_temp);
    window.presTime_f.push("na");
    window.presTime_fDuration.push("na");
  
    window.responses.push(chosenResponse);

    window.allResponses.push(chosenResponse);
    window.allRTs.push(tempRT);

    window.saveScores(formData.trialRow, chosenResponse);
    //timestamps.push(tempTimestamp);
    //RTs.push(tempRT);
    //window.presTime_real.push(window.presTime_real_temp);
    //responses.push(chosenResponse);
    var currentRowNo = computeRowNo(formData.trialRow);
    window.rowRTs[formData.trialRow] = tempRT;
    window.rowResponses[formData.trialRow] = chosenResponse;
    pushRowNo(window.rowNo, currentRowNo);
    if(formInfo.randomizedStimOrder){
      stimOrder_actual.push(getFormActualStimOrder(formInfo.randomizedStimOrder).join(';'));
    }
    else{
      stimOrder_actual.push("na");
    }

    if(formInfo.randomizeResponseRows) {
      responseRowsActual.push(formInfo.responseRows.join(';'));
    } else {
      responseRowsActual.push("na");
    }

    window.stimPos_actual.push("na");

    window.responseCodes[responses.length - 1] = chosenResponseCodes;
    window.allResponseCodes.push(chosenResponseCodes);
    window.rowResponseCodes[formData.trialRow] = chosenResponseCodes;

    var correctVal;
    if (formData.responseKey == "na") {
      correctVal = '0';
    }else{
        correctVal = checkCorrectResponse(formData, chosenResponse, chosenResponseLen, chosenResponseCodes, chosenResponseCodesLen, tempRT);
    }

    window.correct.push(correctVal);
    window.allCorrects.push(correctVal);
    window.rowCorrects[formData.trialRow] = correctVal;

    for (var iCol = 0; iCol < allColumns.length; iCol++)
    {
      saveArrays[iCol].push(listArrays[iCol][formData.trialRow]);
    }
    for (var iCol = 0; iCol < csvNewColumns.length; iCol++)
    {
      saveUnusedArrays[iCol].push(listUnusedArrays[iCol][formData.trialRow]);
    }

    const response = {
      "RT": tempRT ? tempRT : null,
      "response": chosenResponse,
      "responseCode": chosenResponseCodes,
      "timestamp": tempTimestamp,
      "correct": correctVal,
    };

    storeTrial(response, currentRowNo);
  }
  window.saveTallies();
  }

  // empty the displayed form data array
  // displayedFormData.length = 0;

  // empty the generated html
  $('#divQuestionForm').empty();

  // hide the form trials div container
  document.getElementById('divQuestionForm').style.display = 'none';
  document.getElementById('divQuestionForm2').style.display = 'none';


  if (newTrial) {
    window.trial = newTrial;
    window.trialRow = window.stimOrder[window.trial];
  }

  // continue trials
  main();
}

function checkCorrectResponse(formData, chosenResponse, chosenResponseLen, chosenResponseCodes, chosenResponseCodesLen, RT){
    switch (formData.responseType) {
        case 'box':
        case 'comment':
        case 'date':
        case 'stars':
        case 'slider':
            if(formData.multiLineWithImages){
                return verifyMultipleResponseWithImages(formData.responseKey,chosenResponse);
            }else if(formData.hasResponseRows || formData.hasStims){
                return verifyMultipleResponse(formData.responseKey,chosenResponse);
            }

            if(window.keyTrialsLogicFn[formData.trialRow](chosenResponse, chosenResponseCodes, RT)){
            // if(chosenResponse == formData.responseKey){
                return "1";
            }else{
                return "0";
            }
        break;
        case 'radio':
        case 'dropdown':
        case 'rank':
        case 'checkboxes':
            if(formData.multiLineWithImages){
                return verifyMultipleResponseWithImages(formData.responseKey,chosenResponseCodes);
            }else if(formData.hasResponseRows || formData.hasStims){
                return verifyMultipleResponse(formData.responseKey,chosenResponseCodes);
            }

            if(window.keyTrialsLogicFn[formData.trialRow](chosenResponse, chosenResponseCodes, RT) || (formData.responseKey=="0" && chosenResponseCodes=="")){
                return "1";
            }else{
                return "0";
            }
        break;
        default:  // TODO
          return "0";
        break;
    }
}

//check multiple responses in a row with images
function verifyMultipleResponseWithImages(realResponse, userResponse){
    var realResponseChoices = realResponse.split('_').filter(function(c) {return c.length != 0});
    var realUserResponse = userResponse.split('_').filter(function(c) {return c.length != 0});
    var resultString = "";
    for(var i=0; i<realResponseChoices.length; i++ ) {
        resultString += verifyMultipleResponse(realResponseChoices[i], realUserResponse[i]);
        resultString += "_";
    }
    resultString = resultString.substring(0, resultString.length - 1);
    return resultString;
}

//check multiple responses in a row
function verifyMultipleResponse(realResponse, userResponse){
    var realResponseChoices = realResponse.split(';').filter(function(c) {return c.length != 0});
    var emptyResponses = false;
    if(typeof userResponse !== "undefined"){
        var realUserResponse = userResponse.split(';');
    }else{
        var realUserResponse = userResponse;
        emptyResponses = true;
    }
    var resultString = "";
    for(var i=0; i<realResponseChoices.length; i++ ) {
        if(emptyResponses){
            resultString += "0;";
        }else{
            if((realResponseChoices[i] ==  realUserResponse[i]) || (realResponseChoices[i]=="0" && realUserResponse[i]=="")) {
                resultString += "1;";
            }else{
                resultString += "0;";
            }
        }
    }
    resultString = resultString.substring(0, resultString.length - 1);
    return resultString;
}


// https://stackoverflow.com/questions/7753448/how-do-i-escape-quotes-in-html-attribute-values#answer-9756789
function quoteattr(s, preserveCR) {
    preserveCR = preserveCR ? '&#13;' : '\n';
    return ('' + s) /* Forces the conversion to string. */
        .replace(/&/g, '&amp;') /* This MUST be the 1st replacement. */
        .replace(/'/g, '&apos;') /* The 4 other predefined entities, required. */
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        /*
        You may add other replacements here for HTML only
        (but it's not necessary).
        Or for XML, only if the named entities are defined in its DTD.
        */
        .replace(/\r\n/g, preserveCR) /* Must be before the next replacement. */
        .replace(/[\r\n]/g, preserveCR);
        ;
}


// TODO use it (not used atm)
function isSliderValid(formInfo, sliderId) {

  if (formInfo.responseType == 'slider' && formInfo.required && !$('#' + sliderId).data('touched')) {
    return false;
  }

  var inputFieldValue = $('#' + sliderId).val();
  if (formInfo.required && inputFieldValue == '') {
    return false;
  }

  return true;
}

function getNextResponseChoice(randomizeChoices, qresponseOther, qresponseType, randomResponsesHelper, responsesObjectHelper, formInfo, iRCs){
  var responseChoice;
  if (randomizeChoices && randomResponsesHelper) {
    // get a random element
    var maxRand = randomResponsesHelper.length;

    //exlucde the last option from randomization as that's the one from responseOther column if it is defined
    if(qresponseOther != 'na' && qresponseType != "rank" && maxRand > 1){
      maxRand--;
    }
    var randIndex = getRandomInteger(0, maxRand-1);
    responseChoice = randomResponsesHelper[randIndex];
    // remove it from the helper
    randomResponsesHelper.splice(randIndex, 1);
    formInfo.choiceDisplayOrder.push(responsesObjectHelper[responseChoice]);
  } else {
    responseChoice = formInfo.responseChoices[iRCs];

    formInfo.choiceDisplayOrder.push(iRCs);
  }

  return responseChoice;
}

function getFormRandomStimOrder(images, imagesCount, trialRow){
  var initialOrder = [];
  for(var i = 1; i <= imagesCount; i++){
    initialOrder.push(images[i][trialRow]);
  }
  shuffle(initialOrder);
  return initialOrder;
}

function getFormActualStimOrder(randomizedStimuli){
  var stimOrder = [];
  for(var i = 0; i < randomizedStimuli.length; i++){
    var currentSrc = randomizedStimuli[i].src.split('/');
    var imageFileName = currentSrc[currentSrc.length - 1];
    imageFileName = imageFileName.split('.')[0];
    stimOrder.push(imageFileName);
  }
  return stimOrder;
}

function getChosenResponse(formData){
  var chosenResponse = [];
  var chosenResponseCodes = [];

  const responseDelimiter = ';';
  const rowDelimiter = '_';
  const stimuliDelimiter = '|';

  //handle concatanating form responses / responseCodes
  if(formData.stimCountImages){
    var response = getChosenResponseFromFormWithStimuli(formData);
    chosenResponse = response[0];
    chosenResponseCodes = response[1];
  }
  else{
    var response = getChosenResponseFromFormWithoutStimuli(formData);
    chosenResponse = response[0];
    chosenResponseCodes = response[1];
  }

  chosenResponse = removeOnlyDelimitersResponse(chosenResponse);

  return [chosenResponse, chosenResponseCodes];

  function getChosenResponseFromFormWithStimuli(formData){
    var chosenResponse = [];
    var chosenResponseCodes = [];

    //form with image stimuli
    if(formData.multiLine || formData.multiLineOther || formData.multiLineSlider){
      //form with image stimuli and multiple rows
      for(var i = 0; i < formData.stimCountImages; i++){
        var currentStimResponse = [];
        var currentStimResponseCodes = [];
          //each stimuli has formData.stimCount rows responses where formData.response has a total of formdata.stimCountImages * formData.stimCount responses
          for(var j = i*formData.stimCount; j < (i+1)*formData.stimCount; j++){
            var currentRowResponse = getCurrentResponse(formData.response[j], formData.responseCodes[j]);

            if(currentRowResponse[0] != ""){
              currentStimResponse.push(currentRowResponse[0]);
            }
            else{
              currentStimResponse.push("NA");
            }

            if(currentRowResponse[1] != ""){
              currentStimResponseCodes.push(currentRowResponse[1]);
            }
            else{
              currentStimResponseCodes.push("NA");
            }
          }
          currentStimResponse = reorderResponses(currentStimResponse, formData);

          chosenResponse.push(currentStimResponse.join(rowDelimiter));
          if(currentStimResponseCodes.length > 0){
            currentStimResponseCodes = reorderResponses(currentStimResponseCodes, formData);
            chosenResponseCodes.push(currentStimResponseCodes.join(rowDelimiter));
          }
      }
    }
    else{
      //form with image stimuli but not multiple rows
      for(var i = 0; i < formData.response.length; i++){
        var currentResponse = getCurrentResponse(formData.response[i], formData.responseCodes[i]);
        if(currentResponse[0] != ""){
          chosenResponse.push(currentResponse[0]);
        }
        else{
          chosenResponse.push("NA");
        }

        if(currentResponse[1] != ""){
          chosenResponseCodes.push(currentResponse[1]);
        }
        else{
          chosenResponseCodes.push("NA");
        }
      }
    }

    chosenResponse = chosenResponse.join(stimuliDelimiter);
    chosenResponseCodes = chosenResponseCodes.join(stimuliDelimiter);

    return [chosenResponse, chosenResponseCodes];
  }

  function getChosenResponseFromFormWithoutStimuli(formData){
    var chosenResponse;
    var chosenResponseCodes;
    //form without image stimuli
    var currentResponse = [];
    var currentResponseCodes = [];
    for(var i = 0; i < formData.response.length; i++){
      var currentRowResponse = getCurrentResponse(formData.response[i], formData.responseCodes[i]);

      if(currentRowResponse[0] != ""){
        currentResponse.push(currentRowResponse[0]);
      }
      else{
        currentResponse.push("NA");
      }


      if(currentRowResponse[1] != ""){
        currentResponseCodes.push(currentRowResponse[1]);
      }
      else{
        currentResponseCodes.push("NA");
      }
    }

    currentResponse = reorderResponses(currentResponse, formData);
    currentResponseCodes = reorderResponses(currentResponseCodes, formData);

    chosenResponse = currentResponse.join(rowDelimiter);
    chosenResponseCodes = currentResponseCodes.join(rowDelimiter);

    return [chosenResponse, chosenResponseCodes];
  }

  function getCurrentResponse(response, responseCode){
    var currentResponse, currentResponseCodes;

    response = Array.isArray(response) ? response : [response];
    response = response.map(sanitizeResponse);
    responseCode = Array.isArray(responseCode) ? responseCode : [responseCode];

    currentResponse = response.join(responseDelimiter);
    currentResponseCodes = responseCode.join(responseDelimiter);

    return [currentResponse, currentResponseCodes];
  }
  
  //reorders responses if rows were randomized to the order 
  //they would've had if no randomization would've been used
  function reorderResponses(responses, formData) {
    if (!formData.randomizeResponseRows || !formData.responseRowsPermutationTable) {
      return responses;
    }

    const orderedResponses = []
    for(let i = 0; i < responses.length; i++) {
      const currentIndex = formData.responseRowsPermutationTable[i];
      orderedResponses[currentIndex] = responses[i];
    }

    return orderedResponses;
  }

  function sanitizeResponse(response){
    if(typeof response != "string"){
      return response;
    }

    const restrictedCharacters = ['|', ';', '_'];
    const replacementCharacters = ['/', '.', ' '];

    for(var i = 0; i < restrictedCharacters.length; i++){
      response = response.replace(restrictedCharacters[i], replacementCharacters[i]);
    }

    response = removeExclusiveOptionKeyword(response);

    return response;
  }

  function removeOnlyDelimitersResponse(response){
    if(response.match(/^[|_;]+$/)){
      return "";
    }

    if(response.match(/^(NA[|_;])+$/)){
      return "";
    }

    return response;
  }
}

function setHebrewFormAlignment(){
  var formQuestion = document.getElementById('divQuestionForm');
  if(formQuestion){
    setRTLToElement(formQuestion)
  }

  // Get all question head and set hebrew css properties to them
  const questionHeads = document.querySelectorAll('[id^=qformRow] > label')
  questionHeads.forEach(setRTLToElement);

  function setRTLToElement(element) {
    element.style.textAlign = 'right';
    element.style.direction = 'rtl';
    element.style.unicodeBidi = 'bidi-override';
  }
}

function getResponseRowsPermutationAndOrderTable(responseRows, shouldRandomize) {
  if (shouldRandomize != 1) {
    return [responseRows, undefined];
  }
  
  let newOrder = [];
  //create an array containing values from 0 to length - 1
  //use it to generate the new order of rows
  //we save it for later to unscramble the responses
  let newOrderIndexes = [...Array(responseRows.length).keys()];
  shuffle(newOrderIndexes);

  for (let i = 0; i < responseRows.length; i++) {
    newOrder[i] = responseRows[newOrderIndexes[i]];
  }

  return [newOrder, newOrderIndexes];
}